




FUNCTIONS = require "scripts/common"
WP = require "scripts/wordpress"
module.exports =
	components:
		archiveTemplate: require "./archiveTemplate"
	data: ->
		prevPageName: null
		prevPage: null
		prevCategory: null
		archive: { loading: false, content: null, totalPages: [] }
	computed:
		pageName: -> return this.$route.name
		projectName: -> return this.$route.params.projectName
		pageNo: -> return if this.$route.params.page? then this.$route.params.page else 1
		category: -> return if this.$route.params.category? then this.$route.params.category else ""
		isLoading: -> return this.archive.loading
		postType: -> return WP.getArchivePostType(this.pageName.replace("en_",""))
		endPoint: -> return WP.getEndPoint(this.postType)
	methods:
		getPosts: ->
			if this.isLoading then return
			if this.archive.content isnt null then return
			if this.pageName.replace("en_","") is "posts"
				fillter = "projects=" + WP.getProjectID(this.projectName)
				if this.projectName is "all" then fillter = ""
				console.log fillter
				categoryID = WP.getCategoryID(this.$route.params.category)
				if categoryID isnt null then fillter += "&"+WP.getCategoryFillter(categoryID)
			fillter += "&page="+this.pageNo
			WP.getContent(this.endPoint, this.archive, fillter)
	mounted: ->
		this.prevPageName = this.pageName
		this.prevPage = this.pageNo
		this.prevCategory = this.category
		this.archive = { loading: false, content:null, totalPages: [] }
		this.getPosts()
	updated: ->
		if this.prevPage != this.pageNo || this.prevPageName != this.pageName || this.prevCategory != this.category
			this.prevPageName = this.pageName
			this.prevPage = this.pageNo
			this.prevCategory = this.category
			this.archive = { loading: false, content:null, totalPages: [] }
			this.getPosts()



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/archive/archive.vue